import React from 'react';
import { Navigate } from 'react-router';
import { LoadingState } from '@eptai/eptai-app-components';

import { useCanAccessRooms } from '../../hooks/useCanAccessRooms';

type RoomsAccessGuardProps = {
  children: React.ReactNode;
  redirectTo?: string;
};

// public
export default function RoomsAccessGuard({
  children,
  redirectTo = '/',
}: RoomsAccessGuardProps): React.JSX.Element | null {
  const { canAccess, isLoading } = useCanAccessRooms();

  if (isLoading) {
    return <LoadingState variant="spinner" text="Loading access..." />;
  }

  if (!canAccess) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
